module.exports = __webpack_public_path__ + "img/currency_c.5ce23e72.svg";